const mutations = {
  type: 'SET_TYPE',
  percent: 'SET_PERCENT'
}

const IRPF = (percent) => {
  if (!percent) percent = 0
  return {
    type: `8#${percent}`,
    percent,
    specialCode: null,
    specialReason: null
  }
}

const IVA21 = {
  type: '1#21.0',
  percent: 21.0,
  specialCode: null,
  specialReason: null
}

export const initialize = ({ commit, dispatch, state, rootState }) => {
  return new Promise((resolve) => {
    let irpf = rootState.me.settings.irpf
    let taxesList = state.list
    if (taxesList.length > 0) {
      resolve()
      return
    }
    if (irpf !== null && irpf !== undefined) commit('ADD', IRPF(irpf))
    commit('ADD', IVA21)
    resolve()
  })
}

export const addItem = ({ commit }, payload = IVA21) => {
  return new Promise((resolve) => {
    commit('ADD', payload)
    resolve()
  })
}

export const removeItem = ({ commit }, key) => {
  return new Promise((resolve) => {
    commit('DELETE', key)
    resolve()
  })
}

export const updateItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    let key = payload.key
    Object().keys(payload).filter(k => k !== 'key')
    .forEach(param => {
      commit(mutations[param], { key, param, value: payload[param] })
    })
    resolve()
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.map((key) => {
        return dispatch('removeItem', key)
      })
    ]).then(() => {
      resolve()
    })
  })
}
